import PrivateRoutes from "./routes/PrivateRoutes";
import NotLoggedRoutes from "./routes/not-logged-routes";
import { Navigate, Route, Routes, useLocation, useSearchParams } from "react-router-dom";

// Components
import {
    AllPatients,
    ConfirmQuote,
    Help,
    Login,
    Signup,
    DatosPersonaYServicio,
    // Pagos,
    Services,
    Visits,
    QuoteDetails,
    CareHomesBst,
} from "./views";
import Blog from "./views/Blog";
// import Carrito from './views/Carrito';
import DatosPersonaDocumentos from "./views/DatosPersonaDocumentos";
// import Documentos from "./views/Documentos";
// import Facturas from "./views/Facturas";
// import ForgotPassword from './views/ForgotPassword';
import Informes from "./views/informes/Informes";
import Notificaciones from "./views/Notificaciones";
// import Pedidos from './views/Pedidos';
// import Personas from './views/Personas';
// import Producto from './views/Producto';
// import ResetPassword from './views/ResetPassword';
// import SolicitudVisitaServicio from './views/SolicitudVisitaServicio';
// import Subscripciones from './views/Subscripciones';
// import Tienda from './views/Tienda';
import { ConsentSignature } from "./views/consent-signature/consent-signature";
// import Signature from './views/Signature';
import PaymentMethod from "./views/payment-method/payment-method";
import { Profile } from "./views/profile/profile";
import { useSession } from "./hooks";
import { MainLayout, PagesLayout } from "./components/layouts";
import SplitPayment from "./views/split-payment/split-payment";
import TransferPayment from "./views/transfer-payment/transfer-payment";
import CardPayment from "./views/card-payment/card-payment";
import { DataProtection } from "./views/data-protection";
import ResetPassword from "./views/password/reset-password/reset-password";
import ForgotPassword from "./views/password/forgot-password/forgot-password";
import NewHtmlSignForm from "./components/sign/sign-form/new-html-sign-form";
import { useEffect } from "react";
import { useShowMaintenancePopup } from "./hooks/popup/maintenance/use-maintenance-popup";

function App() {
    const { isUserLogged } = useSession();
    const { pathname } = useLocation();
    const [ searchParams ] = useSearchParams();
    const { showMaintenancePopup } = useShowMaintenancePopup();

    const isMaintenanceMode = process.env.REACT_APP_MAINTENANCE_MODE === 'true';
    const hasAccess = sessionStorage.getItem('dev_access') === 'true';
    const isSecretInUrl = searchParams.get('dev') === process.env.REACT_APP_MAINTENANCE_KEY;

    useEffect(() => {
        if (isSecretInUrl) {
            sessionStorage.setItem('dev_access', 'true');
        }
    }, [isSecretInUrl]);

    const isAdmin = isSecretInUrl || hasAccess;

    useEffect(() => {
        if (isMaintenanceMode && !isAdmin) {
            showMaintenancePopup();
        }
    }, [isMaintenanceMode, isAdmin]);

    const regex = /^\/login\/([A-Za-z0-9_-]+\.[A-Za-z0-9_-]+\.[A-Za-z0-9_-]+)$/;
    const isLoginWithToken = regex.test(pathname);

    if (isUserLogged === null) {
        return <div>Cargando sesión...</div>;
    }

    if (isMaintenanceMode && !isAdmin) {
        return (
            <MainLayout>
                <div style={{ height: '100vh', backgroundColor: '#000' }} />
            </MainLayout>
        );
    }

    return (
        <MainLayout>
            <PagesLayout>
                <Routes>
                    {/* Rutas que estaban en el primer bloque (Públicas) */}
                    <Route path="/blog" element={<Blog />} />
                    <Route path="/help" element={<Help />} />
                    <Route path="/residencias/:careHomeBst" element={<CareHomesBst />} />
                    <Route path="/data-protection" element={<DataProtection />} />

                    {/* Resto de rutas unificadas en el mismo árbol */}
                    <Route element={<NotLoggedRoutes isLoginWithToken={isLoginWithToken as boolean} />}>
                        <Route path="/login/:token" element={<Login />} />
                        <Route path="/login" element={<Login />} />
                    </Route>
                    <Route path="/" element={isLoginWithToken ? ( <Login /> ) : isUserLogged ? ( <Navigate to="/personas" replace /> ) : ( <Blog /> )}/>
                    <Route path="/resetPassword/:token" element={<ResetPassword />} />
                    <Route path="/signup" element={<Signup />} />
                    <Route path="/forgotPassword" element={<ForgotPassword />} />
                    {/* <Route path='/users/:userId/:verify' element={<VerifyEmail />} /> */}

                    <Route element={<PrivateRoutes />}>
                        {/* <Route path='/' element={!isUserLogged ? <Navigate to='/login' replace /> : <Blog />} /> */}
                        {/* <Route path='/allPatients' element={<AllPatients />} /> */}
                        {/* <Route path='/carrito' element={<Carrito />} /> */}
                        <Route path="/personas" element={<AllPatients />} />
                        <Route path="/datosPersona/:patientId" element={<DatosPersonaYServicio />} />
                        <Route path="/datosDocumentos/:patientId" element={<DatosPersonaDocumentos />} />
                        {/* <Route path='/documentos/:patientId' element={<Documentos />} /> */}
                        <Route path="/visitas/:patientId" element={<Visits />} />
                        {/* <Route path='/facturas/:patientId' element={<Facturas />} /> */}
                        <Route path="/informes/:patientId" element={<Informes />} />
                        <Route path="/informeDetallado/:patientId/:reportId" element={<QuoteDetails />} />
                        <Route path="/informeDetallado/:patientId/:reportId/confirmation" element={<ConfirmQuote />} />
                        <Route path="/informeDetallado/:patientId/:reportId/firmaConsentimiento" element={<ConsentSignature />} />
                        <Route path="/informeDetallado/:patientId/:reportId/paymentMethod" element={<PaymentMethod />} />
                        <Route path="/informeDetallado/:patientId/:reportId/paymentMethod/cardpayment" element={<CardPayment />} />
                        <Route path="/informeDetallado/:patientId/:reportId/paymentMethod/transferpayment" element={<TransferPayment />} />
                        <Route path="/informeDetallado/:patientId/:reportId/paymentMethod/splitpayment" element={<SplitPayment />} />
                        <Route path="/informeDetallado/:patientId/:reportId/paymentMethod/splitpayment/:docId" element={<NewHtmlSignForm />} />
                        {/* <Route path='/informeDetallado/:patientId/:reportId/signature' element={<Signature />} /> */}
                        {/* <Route path='/informeDetallado/:patientId/:reportId/sign-document' element={<HtmlSignForm />} /> */}
                        <Route path="/informeDetallado/:patientId/:reportId/sign-document/:docId/" element={<NewHtmlSignForm />} />
                        <Route path="/notificaciones" element={<Notificaciones />} />
                        {/* <Route path='/pagos' element={<Pagos />} /> */}
                        {/* <Route path='/pedidos' element={<Pedidos />} /> */}
                        {/* <Route path='/personas' element={<Personas />} /> */}
                        {/* <Route path='/producto/:itemId' element={<Producto />} /> */}
                        <Route path="/servicios" element={<Services />} />
                        {/* <Route path='/solicitudVisitaServicio' element={<SolicitudVisitaServicio />} /> */}
                        {/* <Route path='/subscripciones' element={<Subscripciones />} /> */}
                        {/* <Route path='/tienda' element={<Tienda />} /> */}
                        <Route path="/profile" element={<Profile />} />
                    </Route>
                </Routes>
            </PagesLayout>
        </MainLayout>
    );
}

export default App;
